<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start>
    <v-layout
      justify-center
      wrap>
      <v-flex >
        <v-layout>
          <v-flex
            xs12
            md5
            xl5
            class="masterDropdown">

            <router-link
              :to="'/admin/account-inventory/customers'"
              tag="div">
              <v-btn><v-icon
                color="primary"
                class="mr-2">arrow_back</v-icon> Go back to Customer List</v-btn>
            </router-link>

            
          </v-flex>
        </v-layout>
        <formAdminAccountsDatatable
          :title="`Accounts under: ${this.customerName}`"
          :type="'byCustomer'"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({

  }),
  computed: {
    customerName: {
      get() {
        let customerId = this.$route.params.id
        let customer = this.$store.state['admin/accountInventory'].customerAccounts.find( cust => cust.Customer_Id == customerId)
        return customer.Customer_Name
      }
    }
  },
  methods: {

  },
  mounted() {
    this.$store.commit('admin/accountInventory/removeSearchValue')
    this.$store.commit('admin/accountInventory/clearAccounts')
    let customerId = this.$route.params.id
    this.$store.commit('admin/accountInventory/setAccountFilters', {Customer_Id: customerId, Acct_Status: [] })
  },
}
</script>
<style lang="scss">
</style>
